/**
 * Classe de view da funcionalidade events manage.
 * @author: adalto.junior
 * Date: 12/10/13
 * Time: 11:44
 */

Greenmile.Event = Greenmile.Event || {};

Greenmile.Event.call = function (property) {
  return (function percorrer(property, objeto) {
    const properties = property.split('.');
    objeto = objeto[properties.shift()];
    return (properties.length > 0 && typeof objeto !== 'undefined') ? percorrer(properties.join('.'), objeto) : objeto;
  }(property, this));
};

App.Views.Event = {
  layouts: {
    ARRIVAL_DEPARTURE_DEVIATION_TEMPLATE: Greenmile.Checks.EventCheck.ArrivalDepartureDeviation,
    RETURN_TO_CHECKPOINT_TEMPLATE: Greenmile.Checks.EventCheck.ReturnToCheckpoint,
    DELIVERY_AND_SEND_MERCHANDISER_TEMPLATE: Greenmile.Checks.EventCheck.DeliveryAndSendMerchandiser,
    DISTANCE_CUSTOMER_TEMPLATE: Greenmile.Checks.EventCheck.DistanceCustomer,
    DRIVER_AT_HOME_TEMPLATE: Greenmile.Checks.EventCheck.DriverHome,
    GEOFENCE_TEMPLATE: Greenmile.Checks.EventCheck.Geofence,
    GPS_GAP_TEMPLATE: Greenmile.Checks.EventCheck.GpsGap,
    IDLE_GPS_TEMPLATE: Greenmile.Checks.EventCheck.IdleGps,
    LATE_DEPART_ORIGIN_TEMPLATE: Greenmile.Checks.EventCheck.LateDepartOrigin,
    LATE_START_ROUTE_TEMPLATE: Greenmile.Checks.EventCheck.LateStartRoute,
    LATE_GPS_TEMPLATE: Greenmile.Checks.EventCheck.LateGps,
    EVENT_NO_ATTRIBUTES_TEMPLATE: Greenmile.Checks.EventCheck.NoAttributes,
    STR: Greenmile.Checks.EventCheck.NoAttributes,
    OFF_PLANNED_TEMPLATE: Greenmile.Checks.EventCheck.OffPlanned,
    OS_AND_D_MONITORING_TEMPLATE: Greenmile.Checks.EventCheck.OSDMonitoring,
    PLANNED_PROJECTED_ARRIVAL_DEVIATION_TEMPLATE: Greenmile.Checks.EventCheck.PlannedProjectedArrivalDeviation,
    ROUTE_PATH_DEVIATION_TEMPLATE: Greenmile.Checks.EventCheck.RoutePathDeviation,
    SERVICE_TIME_TEMPLATE: Greenmile.Checks.EventCheck.ServiceTime,
    SPEED_VIOLATION_TEMPLATE: Greenmile.Checks.EventCheck.SpeedViolation,
    STOP_CANCEL_TEMPLATE: Greenmile.Checks.EventCheck.StopCancel,
    TELEMATICS_TEMPLATE: Greenmile.Checks.EventCheck.Telematic,
    UNDELIVERABLE_STOP_TEMPLATE: Greenmile.Checks.EventCheck.UndeliverableStop,
    UNPLANNED_STOP_TEMPLATE: Greenmile.Checks.EventCheck.UnplannedStop,
    IDLE_DRIVERS_TEMPLATE: Greenmile.Checks.EventCheck.IdleDrivers,
    TAGS_TEMPLATE: Greenmile.Checks.EventCheck.Tags,
    EMAIL_TEMPLATE: Greenmile.Actions.EMAIL,
    DATABASE_INTEGRATION_TEMPLATE: Greenmile.Actions.DatabaseIntegration,
    DELIVERY_ALERT_TEMPLATE: Greenmile.Actions.DeliveryAlert,
    SMS_TEMPLATE: Greenmile.Actions.SMS,
    HTTP_REQUEST_TEMPLATE: Greenmile.Actions.HttpRequest,
    NO_ATTRIBUTES: Greenmile.Checks.EventCheck.NoAttributes,
    MOVEMENT_NOT_ALLOWED_TEMPLATE: Greenmile.Checks.EventCheck.MovementNotAllowed,
    ON_OFF_DUTY_ALERT_TEMPLATE: Greenmile.Checks.EventCheck.OnOffDutyAlert,
    MINIMUM_REST_TIME_TEMPLATE: Greenmile.Checks.EventCheck.MinimumRestTime,
    LUNCH_ALERT_TEMPLATE: Greenmile.Checks.EventCheck.LunchAlert,
    MAX_ON_DUTY_ALERT_TEMPLATE: Greenmile.Checks.EventCheck.MaxOnDutyAlert,
    MINIMUM_LUNCH_TIME_TEMPLATE: Greenmile.Checks.EventCheck.NoAttributes,
    ROUTE_OUT_OF_SEQUENCE_TEMPLATE: Greenmile.Checks.EventCheck.RouteOutOfSequence,
    STOP_REDELIVERY_TEMPLATE: Greenmile.Checks.EventCheck.StopRedelivery,
    MISSED_TIME_WINDOW_TEMPLATE: Greenmile.Checks.EventCheck.MissedTimeWindow,
    LATE_ARRIVAL_TEMPLATE: Greenmile.Checks.EventCheck.LateArrival,
    NEXT_STOP_TEMPLATE: Greenmile.Checks.EventCheck.NextStop,
    ROUTE_STATUS_WAS_CHANGED_TEMPLATE: Greenmile.Checks.EventCheck.RouteStatusWasChanged,
    ROUTE_DRIVER_OR_EQUIPMENT_WAS_ASSIGNED_TEMPLATE: Greenmile.Checks.EventCheck.RouteDriverOrEquipmentAssigned,
    EXCESS_POST_ROUTE_TIME_TEMPLATE: Greenmile.Checks.EventCheck.ExcessPostRouteTime,
    MANAGER_NOTIFICATION_TEMPLATE: Greenmile.Actions.ManagerNotification
  },
  sideBarLayout: {
    items: [
      {
        items: [
          {
            items: [
              {
                items: [
                  {
                    tag: 'span',
                    html: 'event.check',
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  id: 'tree-library-check-title',
                },
              },
              {
                attributes: {
                  class: 'sideBarItemContent',
                  id: 'tree-library-check',
                },
              },
              {
                items: [
                  {
                    tag: 'span',
                    html: 'event.action',
                    attributes: {
                      class: 'i18nResource',
                    },
                  },
                ],
                attributes: {
                  id: 'tree-library-action-title',
                },
              },
              {
                attributes: {
                  class: 'sideBarItemContent',
                  id: 'tree-library-action',
                },
              },
            ],
            attributes: {
              class: 'well sidebar-nav',
            },
          },
        ],
        attributes: {
          class: 'span2',
          style: 'display: block',
        },
      }
    ],
  },

  showNoChecks() {
    let allHide = true;

    $('*[id*=check-form-]').each((x, y) => {
      if (y.style.display !== 'none' && y.style.display !== '') {
        allHide = false;
      }
    });

    if (allHide) {
      $('#show-no-checks').fadeIn('slow');
    }
  },

  showNoActions() {
    let allHide = true;

    $('*[id*=action-form-]').each((x, y) => {
      if (y.style.display !== 'none' && y.style.display !== '') {
        allHide = false;
      }
    });

    if (allHide) {
      $('#show-no-actions').fadeIn('slow');
    }
  },
  formatItemsRulesOfTree: (data) => {
    const gmeventChecks = data.first().get('gmeventChecks') || [];
    const geotabEventChecks = data.first().get('geotabEventChecks') || [];

    const nodes = [];

    gmeventChecks.forEach(event => {
      const nodeChild = {
        attr: {
          libraryId: event.id,
        },
        data: Monet.I18n.getResourcesByKey(event.description),
        state: 'close',
      };
      const libraryChildren = event.eventLibraryChecks || event.eventLibraryActions;
      if (libraryChildren && libraryChildren.length) {
        nodeChild.state = 'open';
        nodeChild.children = [];
        libraryChildren.forEach((eventLibrary) => {
          nodeChild.children.push({
            data: Monet.I18n.getResourcesByKey(eventLibrary.description),
            attr: {
              libraryId: eventLibrary.id,
            }
          });
        });
      }
      nodes.push(nodeChild);
    });

    if (geotabEventChecks.length) {
      const geoTabToEventsCheck = {
        id: 'geotabEvents',
        eventLibraryChecks: []
      };

      const nodeChild = {
        attr: {
          libraryId: null,
        },
        data: Monet.I18n.getResourcesByKey('Greenmile.Event.geoTabDescription'),
        state: 'open',
        children: []
      };
      geotabEventChecks.forEach(event => {
        const objGeoTabFormatted = {
          externalDescription: event.name,
          externalID: event.externalId,
          externalComment: event.comment,
          externalHelpResource: event.helper
        };
        nodeChild.attr.libraryId = event.externalId;

        nodeChild.children.push({
          data: Monet.I18n.getResourcesByKey(objGeoTabFormatted.externalDescription),
          attr: {
            libraryid: objGeoTabFormatted.externalID
          }
        });

        geoTabToEventsCheck.eventLibraryChecks.push(objGeoTabFormatted);
        Monet.Session.EventsManage.geoTabsOnTreeView.push(objGeoTabFormatted.externalID);
      });

      const geotabEvents = Monet.Session.EventsManage.eventsCheck.filter(item => item.id === geoTabToEventsCheck.id);
      if (!geotabEvents.length) {
        Monet.Session.EventsManage.eventsCheck.push(geoTabToEventsCheck);
      } else {
        geotabEvents.eventLibraryChecks = geoTabToEventsCheck.eventLibraryChecks;
      }
      nodes.push(nodeChild);
    }

    return nodes;
  },
  formatItemsActionsOfTree: (data) => {
    const nodes = [];
    data.models.forEach((event) => {
      const nodeChild = {
        attr: {
          libraryId: event.get('id'),
        },
        data: Monet.I18n.getResourcesByKey(event.get('description')),
        state: 'close',
      };
      const libraryChildren = event.get('eventLibraryChecks') || event.get('eventLibraryActions');
      if (libraryChildren && libraryChildren.length) {
        nodeChild.state = 'open';
        nodeChild.children = [];
        libraryChildren.forEach((eventLibrary) => {
          nodeChild.children.push({
            data: Monet.I18n.getResourcesByKey(eventLibrary.description),
            attr: {
              libraryId: eventLibrary.id,
            }
          });
        });
      }
      nodes.push(nodeChild);
    });
    return nodes;
  },
  mountEventsTree: (element, nodes, dropFinished, afterLoaded) => {
    $(element).jstree({
      json_data: {
        data: nodes,
      },
      dnd: {
        check_timeout: 1200,
        drop_target: ".jstree-drop",
        drop_finish(data) {
          dropFinished(data);
        },
      },
      crrm: {
        move: {
          check_move() {
            return false;
          },
        },
      },
      plugins: ['json_data', 'dnd', 'crrm'],
    }).on('click', 'a', (event) => {
      event.preventDefault();
    }).on('loaded.jstree', () => {
      if (afterLoaded) {
        afterLoaded();
      }
    });
  },
  mountTreeCheck(nodes) {
    App.Views.Event.mountEventsTree('#tree-library-check', nodes, (data) => {
      App.Views.Event.renderEventItem(
        data, Monet.Session.EventsManage.eventsCheck, App.Views.Event.renderCheckBoxById
      );
    }, () => {
      App.Views.Event.checkGeoTabEventsIsOkAndDisableBox();
    });
  },

  mountTreeAction(nodesAction) {
    App.Views.Event.mountEventsTree('#tree-library-action', nodesAction, (data) => {
      App.Views.Event.renderEventItem(
        data, Monet.Session.EventsManage.eventsAction, App.Views.Event.renderActionBox
      );
    });
  },
  renderEventItem: (data, events, eventRenderer) => {
    events.forEach((event) => {
      const librariesChildren = event.eventLibraryChecks || event.eventLibraryActions;
      librariesChildren.forEach((eventLibrary) => {
        const libraryCheckId = $(data.o).attr('libraryid');
        const id = (eventLibrary.externalID) ? eventLibrary.externalID.toString() : eventLibrary.id.toString();
        if (id === libraryCheckId) {
          eventRenderer(eventLibrary);
        }
      });
    });
  },
  checkIfEventExists: (selector, id) => document.querySelector(`${selector} div[eventid="${id}"]`),
  getEventBox: (eventId, title, content, kind, afterClose) => {
    const onClose = (e) => {
      $(e.target).parents('div.box-event').remove();
      if (afterClose) {
        afterClose(e);
      }
    };
    const html = `
      <div class="box-event" id="${kind}-${eventId}" eventId="${eventId}">
          <div class="box-title">
          <div class="box-title-icon"></div>
          <div style="float: left;">
            <span class="i18nResource">${Monet.I18n.getResourcesByKey(title)}</span></div>
          <div class="box-close"></div>
        </div>
        <div class="box-content"></div>
      </div>`;

    const box = new DOMParser().parseFromString(html, 'text/html').body.firstChild;
    if (content) {
      box.querySelector('.box-content').appendChild(content);
    }
    box.querySelector('.box-close').addEventListener('click', onClose, false);
    return box;
  },

  renderEventBox: (event, kind, afterClose) => {
    const template = App.Views.Event.layouts[event.htmlTemplate].template;
    const unitSystemKey = (Monet.Session.User.unitSystem === 'NON_METRIC') ?
                    'Greenmile.UnitMetrics.milesAbreviationParentheses' : 'Greenmile.UnitMetrics.mettersAbreviationParentheses';

    const templateRendered = (new Monet.UI.LayoutGenerator(template({
      label: Monet.I18n.getResourcesByKey('event.arrivaldeparture.distance', Monet.I18n.getResourcesByKey(unitSystemKey)),
      key: event.key,
    })).render());

    [...templateRendered.querySelectorAll('.i18nResource')].forEach((item) => {
      item.innerHTML = Monet.I18n.getResourcesByKey(item.innerHTML);
    });

    return App.Views.Event.getEventBox(
      event.id, event.description, templateRendered, kind, afterClose
    );
  },
  renderCheckBoxById: (event) => {
    if (event.externalID) {
      App.Views.Event.renderGeoTabCheckBox(event);
    } else {
      App.Views.Event.renderCheckBox(event);
    }
  },
  hideMessageNoRulesOrAction: (selector) => {
    const element = document.querySelector(selector);
    if (element.style.display !== 'none') {
      element.style.display = 'none';
    }
  },
  renderCheckBox(event, evtCheck) {
    if (!App.Views.Event.checkIfEventExists('[key$="check_event"]', event.id)) {
      App.Views.Event.hideMessageNoRulesOrAction('#show-no-checks');
      const kind = 'check-form';
      const closeBox = App.Views.Event.showNoChecks;
      document.querySelector('#append-check-area').appendChild(
        App.Views.Event.renderEventBox(event, kind, closeBox)
      );

      if (evtCheck) {
        $(`#${kind}-${event.id}`).attr('eventcheckid', evtCheck.id);
      }
      if (event.jsAssignParameter !== '' && event.jsAssignParameter !== 'STR') {
        const functionToAssignParameter = App.Views.Event.layouts[event.htmlTemplate].assignParameter;
        if (functionToAssignParameter) {
          const param = (evtCheck) ? evtCheck.jsonParameter : null;
          functionToAssignParameter(param);
        }
      }
    }
  },

  renderActionBox(event, evtAction) {
    if (!App.Views.Event.checkIfEventExists('[key$="action_event"]', event.id)) {
      App.Views.Event.hideMessageNoRulesOrAction('#show-no-actions');
      const kind = 'action-form';
      const closeBox = () => {
        App.Views.Event.showNoActions();
      };

      document.querySelector('#append-action-area').appendChild(
        App.Views.Event.renderEventBox(event, kind, closeBox)
      );

      switch (event.htmlTemplate) {
        case 'SMS_TEMPLATE':
          const sms = Greenmile.Actions.SMS;
          sms.addListener();
          sms.prepareBodyComponent();
          break;
        case 'DELIVERY_ALERT_TEMPLATE': {
          const deliveryAlertAction = Greenmile.Actions.DeliveryAlert;
          deliveryAlertAction.prepareBodyComponent();
          deliveryAlertAction.prepareDeliveryAlertAction();
          break;
        }
        case 'EMAIL_TEMPLATE': {
          const email = Greenmile.Actions.EMAIL;
          email.addListener();
          email.prepareBodyComponent();
          break;
        }
        case 'MANAGER_NOTIFICATION_TEMPLATE': {
          const managerNotification = Greenmile.Actions.ManagerNotification;
          managerNotification.initManagerNotificationAction();
          break;
        }
        case 'HTTP_REQUEST_TEMPLATE': {
          const HttpRequest = Greenmile.Actions.HttpRequest;
          HttpRequest.prepareBodyComponent();
          break;
        }
        default:
          console.log('Will be used NO_ATTRIBUTES template');
          break;
      }

      let jsonParameter;

      if (typeof evtAction !== 'undefined') {
        $(`#${kind}-${event.id}`).attr('eventactionid', evtAction.id);
        jsonParameter = evtAction.jsonParameter;
      }
      if (event.jsAssignParameter !== '' && event.jsAssignParameter !== 'STR' && typeof jsonParameter !== 'undefined') {
        Greenmile.Event.call(event.jsAssignParameter)(jsonParameter);
      }
      Greenmile.Event.AutoComplete.markFields('entity');
    }
  },

  renderGeoTabCheckBox(evtCheck) {
    if (!App.Views.Event.checkIfEventExists('[key$="check_event"]', evtCheck.externalID)) {
      App.Views.Event.hideMessageNoRulesOrAction('#show-no-checks');
      const kind = 'check-form';
      const htmlTemplate = document.createElement('span');
      const closeBox = (e) => {
        App.Views.Event.showNoChecks();
        App.Views.Event.removeFromGeoTabSavedIfExists(e.target.getAttribute('eventId'));
      };

      if (evtCheck.externalComment) {
        htmlTemplate.innerHTML = evtCheck.externalComment;
      } else if (evtCheck.externalHelpResource) {
        htmlTemplate.innerHTML = Monet.I18n.getResourcesByKey(evtCheck.externalHelpResource);
      }

      document.querySelector('#append-check-area').appendChild(
        App.Views.Event.getEventBox(
          evtCheck.externalID, evtCheck.externalDescription, htmlTemplate, kind, closeBox
        )
      );
      if (evtCheck && evtCheck.id) {
        $(`#${kind}-${evtCheck.externalID}`).attr('eventcheckid', evtCheck.id);
      }
    }
  },
  getEventsGeoTabOff() {
    const geoTabsOnSaved = Monet.Session.EventsManage.geoTabsOnSaved || [];
    const geoTabsOnTreeView = Monet.Session.EventsManage.geoTabsOnTreeView || [];
    const geoTabEventsOff = [];

    geoTabsOnSaved.forEach((geoTab) => {
      if (geoTabsOnTreeView.indexOf(geoTab.externalID) === -1) {
        geoTabEventsOff.push(geoTab);
      }
    });
    return geoTabEventsOff;
  },

  checkGeoTabEventsIsOkAndDisableBox() {
    const geoTabEventsOff = App.Views.Event.getEventsGeoTabOff();
    geoTabEventsOff.forEach((geoTabEvent) => {
      const geoTabBox = document.querySelector(`#check-form-${geoTabEvent.externalID}`);
      if (geoTabBox && geoTabBox.className.indexOf('disabled') !== -1) {
        geoTabBox.className += ' disabled';
      }
    });
  },

  removeFromGeoTabSavedIfExists(eventId) {
    const eventsSaved = Monet.Session.EventsManage.geoTabsOnSaved;
    for (let i = 0, length = eventsSaved.length; i < length; i++) {
      if (eventsSaved[i].externalID === eventId) {
        eventsSaved.splice(i, 1);
        break;
      }
    }
  },
  renderForm: (crud, afterCreateForm) => {
    const tabName = 'Event';
    const layout = App.Forms.Event.layout[crud];
    const baseRouter = new App.Routers.BaseRouter();
    baseRouter.crudStage = crud;
    baseRouter.updateTabTitle(layout);

    if (!baseRouter.permissionDenied) {
      const tab = document.getElementById(tabName);
      const form = new Monet.Builder.Form.Horizontal(layout, tabName);
      const template = (new Monet.UI.LayoutGenerator(App.Views.Event.sideBarLayout)).render();
      [...template.querySelectorAll('.i18nResource')].forEach((item) => {
        item.innerHTML = Monet.I18n.getResourcesByKey(item.innerHTML);
      });
      form.setCrudStage(crud);
      tab.innerHTML = '';
      tab.appendChild(template);
      tab.appendChild(form.render());
      form.rootEl.className = `jstree-drop ${form.rootEl.className}`;

      const plsCheckEvent = form.rootEl.querySelector('[key$="check_event"]');
      const plsActionEvent = form.rootEl.querySelector('[key$="action_event"]');
      const divShowNoCheck = document.createElement('div');
      const divShowNoActions = document.createElement('div');
      divShowNoCheck.id = 'show-no-checks';
      divShowNoActions.id = 'show-no-actions';
      divShowNoCheck.innerHTML = `<span class="i18nResource">${Monet.I18n.getResourcesByKey('event.dragdrop.check')}</span>`;
      divShowNoActions.innerHTML = `<span class="i18nResource">${Monet.I18n.getResourcesByKey('event.dragdrop.action')}</span>`;

      plsCheckEvent.id = 'append-check-area';
      plsActionEvent.id = 'append-action-area';
      plsCheckEvent.appendChild(divShowNoCheck);
      plsActionEvent.appendChild(divShowNoActions);
      form.fields.exibitionMode.setSelectedValue('NORMAL');
      form.fields.requiresComment.disable();
      form.fields.requiresAck.addClickEventListener(() => {
        if (form.fields.requiresAck.getValue()) {
          form.fields.requiresComment.enable();
        } else {
          form.fields.requiresComment.disable();
          form.fields.requiresComment.setChecked(false);
        }
      });

      const eventLibrary = new Greenmile.EventLibrary();
      const bubblingMask = document.createElement('div');
      const bubbleButton = document.createElement('div');

      bubblingMask.id = 'bubbling-mask';
      bubbleButton.id = 'bubble-button';
      bubblingMask.className = 'message-body';
      form.fields.icon.setTextLabel(Monet.I18n.getResourcesByKey('event.icon'));
      form.fields.icon.images = eventLibrary.images;
      form.fields.messageBody.rootEl.querySelector('textarea').className = 'message-body autocomplete_entity';
      form.fields.messageBody.rootEl.querySelector('div').appendChild(bubblingMask);
      form.fields.messageBody.rootEl.querySelector('div').appendChild(bubbleButton);
      App.Forms.Event.form = form;
      App.Objects.Event.loadEventsCheck();
      App.Objects.Event.loadEventsAction();
      Greenmile.Event.AddAttribute.prepareAddAtribute('#Event_messageBody', '[name="messageBody"]');
      Greenmile.Event.AutoComplete.markFields('entity');

      if (afterCreateForm) {
        afterCreateForm();
      }
    }
  },
  inlineMessage: (validation) => {
    const monetMessage = new Monet.Form.Messages.InlineMessage();
    monetMessage.setScope('#Event');
    monetMessage.setInfoType('error');
    monetMessage.setMessage(validation);
    monetMessage.triggerMessage();
  },
};
